module.exports = __webpack_public_path__ + "img/unrisd-logo-desktop.f4ed9b71.png";